// Import warning helpers keep import-stage diagnostics short and consistent.
// Example: unresolved `.luis` imports should emit one stable warning object.
import type { LuisCompileWarning } from '../types'
import type { ImportResolveContext } from './types'

// Build one import-stage warning write into the shared resolution context.
export function pushImportWarning(
  context: ImportResolveContext,
  code: LuisCompileWarning['code'],
  line: number,
  message: string,
): void {
  // Append one stable warning payload to the shared import context.
  context.warnings.push({ code, line, message })
}
